userActionJudgeSp();
scrollBox();

function userActionJudgeSp() {
  const formInput = document.querySelectorAll('.js-formInputClass');
  const formInputList = Array.prototype.slice.call(formInput, 0);
  const fixBnrEle = document.querySelector('.js-fixBnr');

  formInputList.forEach((targetBox) => {
    let ut = navigator.userAgent;

    if (ut.indexOf('iPhone') > 0 || ut.indexOf('iPod') > 0 || (ut.indexOf('Android') > 0 && ut.indexOf('Mobile') > 0)) {
      targetBox.addEventListener('focus', () => {
        fixBnrEle.classList.add('is-hide');
      });

      targetBox.addEventListener('blur', () => {
        fixBnrEle.classList.remove('is-hide');
      });
    }
  });
}

function scrollBox() {
  if (document.querySelector('.js-submitBtn')) {
    let submitBtnFlag = false;
    const submitBtnEle = document.querySelector('.js-submitBtn');

    const scrollBoxPrivacyEle = document.querySelector('.js-scrollBoxPrivacy');
    const scrollJudgeEle = document.querySelectorAll('.js-scrollJudge');
    const scrollJudgeInputEle = document.querySelectorAll('.js-scrollJudge input');

    // チェックボックスアクティブ化
    if (document.querySelector('.js-scrollBoxIntro')) {
      const scrollBoxIntroEle = document.querySelector('.js-scrollBoxIntro');
      scrollJudge(scrollBoxIntroEle);
    }

    scrollJudge(scrollBoxPrivacyEle);

    // 送信ボタンアクティブ化
    scrollJudgeEle.forEach((target) => {
      const judgeCheck = target.querySelector('input');

      judgeCheck.addEventListener('change', () => {
        if (judgeCheck.checked === false) {
          judgeCheck.classList.add('is-false');
        } else {
          judgeCheck.classList.remove('is-false');
        }

        if (document.querySelector('.js-scrollJudge input.is-false')) {
          submitBtnEle.disabled = true;
        } else {
          const scrollJudgeTrueEle = document.querySelectorAll('.js-scrollJudge.is-false');
          if (scrollJudgeTrueEle.length == 0) {
            submitBtnEle.disabled = false;
          }
        }
      });
    });
  }

  function scrollJudge(element) {
    element.addEventListener('scroll', (e) => {
      const scrollElementHeight = element.scrollHeight - element.scrollTop;
      const elementClientHeight = element.scrollHeight - element.scrollTop;
      const judgeHeight = element.clientHeight + 320;

      if (element.scrollHeight - element.scrollTop <= judgeHeight) {
        const privacyJudge = element.parentNode.nextElementSibling.querySelector('input');
        element.parentNode.nextElementSibling.classList.remove('is-disabled');
        privacyJudge.disabled = false;
      } else {
      }
    });
  }
}
//
